<template>
  <div v-if="!isLoaded">
    <page-header v-if="showHeader" :right-actions="[]" show-logo bottom-border :logo-color="logoColor" />
    <content-loader />
  </div>
  <router-view v-else />
</template>

<script>
import _ from 'lodash';
import store from '@/store';
import BaseUI from '@riseupil/base-ui';
import ContentLoader from '@/base-components/ContentLoader';
import AppFrameMixin from '@/mixins/AppFrameMixin';
import Intercom from '@/Intercom';

export default {
  name: 'OtsAuthenticateToken',
  data() {
    return {
      isLoaded: false,
      logoColor: BaseUI.Colors.riseupYellow,
    };
  },
  mixins: [AppFrameMixin],
  components: {
    ContentLoader,
    PageHeader: BaseUI.PageHeader,
  },
  async created() {
    await this.initCustomerState();
  },
  methods: {
    async initCustomerState() {
      await store.dispatch('contentLoader/startContentLoading', 'customerState');
      await store.dispatch('featureFlags/init');
      await Promise.all(_.compact([
        store.dispatch('session/init', {
          incognito: this.$route.query.incognito,
          name: this.$route.name,
          segmentEventPrefix: 'Ots_',
        }),
      ]));
      // We dont wait for intercom update as it is external service that might be slow
      // and we dont want to delay the UI infavor of it...
      // eslint-disable-next-line
      Intercom.update(this.customerId, this.householdName);
      await store.dispatch('contentLoader/doneContentLoading', 'customerState');
      this.isLoaded = true;
    },
  },
};

</script>
